/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { ServiceUserLieGridDto } from './ServiceUserLieGridDto';
import {
    ServiceUserLieGridDtoFromJSON,
    ServiceUserLieGridDtoFromJSONTyped,
    ServiceUserLieGridDtoToJSON,
} from './ServiceUserLieGridDto';

/**
 * 
 * @export
 * @interface ServiceUserLieGridDtoPaginatedResults
 */
export interface ServiceUserLieGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ServiceUserLieGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ServiceUserLieGridDto>}
     * @memberof ServiceUserLieGridDtoPaginatedResults
     */
    results?: Array<ServiceUserLieGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ServiceUserLieGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ServiceUserLieGridDtoPaginatedResults interface.
 */
export function instanceOfServiceUserLieGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceUserLieGridDtoPaginatedResultsFromJSON(json: any): ServiceUserLieGridDtoPaginatedResults {
    return ServiceUserLieGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ServiceUserLieGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceUserLieGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ServiceUserLieGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ServiceUserLieGridDtoPaginatedResultsToJSON(value?: ServiceUserLieGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ServiceUserLieGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

